module.exports = __webpack_public_path__ + "static/media/o-lider-em-mim.b806f8d9.png";